import { useState } from 'react';
import LocationService from '../../Core/Services/LocationService';
import ArrowRightIcon from '../Icons/ArrowRightIcon';

function LocationItem({ onSelect, location, selected }) {
  const pluginUrl = LocationService.getPluginUrl();
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="locationItem p-4 flex justify-between items-center cursor-pointer"
      style={{
        backgroundColor: selected
          ? hovered
            ? '#1d4ed8'
            : '#2563eb'
          : hovered
            ? '#f3f4f6'
            : '',
        color: selected ? 'white' : '',
      }}
      role="button"
      tabIndex={0}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onSelect(location.id)}
      onKeyDown={e => {
        if (e.key === 'Enter') onSelect(location.id);
      }}
    >
      <div className="ml-2 mt-2 mb-2">
        <h2
          className="text-2xl font-bold location-title relative pl-10"
          style={{
            '--marker-url': `url(${pluginUrl}marker.png)`,
          }}
        >
          <span
            aria-hidden="true"
            style={{
              backgroundImage: `url(${pluginUrl}marker.png)`,
              position: 'absolute',
              left: '-5px',
              top: '0px',
              width: '30px',
              height: '50px',
              display: 'inline-block',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '50% 0',
              backgroundSize: 'auto 100%',
            }}
          />
          {location.name.toUpperCase()}
        </h2>
        <p className={`font-normal text-sm pl-10 mt-2 `}>{location.address}</p>
      </div>
      <div className="border border-solid border-gray-400 border-1 flex h-14 w-14 items-center justify-center ">
        <ArrowRightIcon className="size-6" />
      </div>
    </div>
  );
}
export default LocationItem;
